import React from 'react';
import { MapPinIcon } from 'lucide-react';
const footerLinks = {
  empresa: [{
    label: 'Nosotros',
    href: '#nosotros'
  }, {
    label: 'Blog',
    href: '#'
  }, {
    label: 'Carreras',
    href: '#'
  }, {
    label: 'Contacto',
    href: '#contacto'
  }],
  soluciones: [{
    label: 'Flotillas',
    href: '#soluciones'
  }, {
    label: 'Auto Particular',
    href: '#soluciones'
  }, {
    label: 'Transporte de Carga',
    href: '#soluciones'
  }, {
    label: 'Motocicletas',
    href: '#soluciones'
  }, {
    label: 'Monitoreo 24/7',
    href: '#soluciones'
  }],
  productos: [{
    label: 'Queclink',
    href: '#gps'
  }, {
    label: 'JIMI IoT',
    href: '#gps'
  }, {
    label: 'Suntech',
    href: '#gps'
  }, {
    label: 'Dashcam',
    href: '#plataforma'
  }],
  contacto: [{
    label: '+52 55 1234 5678',
    href: 'tel:+525512345678'
  }, {
    label: 'contacto@trackerspacemx.com',
    href: 'mailto:contacto@trackerspacemx.com'
  }, {
    label: 'Ciudad de México, México',
    href: '#'
  }]
};
export function Footer() {
  return <footer className="w-full bg-brand-bg border-t border-cyan-subtle relative overflow-hidden" data-id="element-99">
      {/* Background Grid */}
      <div className="absolute inset-0 bg-grid opacity-5" data-id="element-100" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16" data-id="element-101">
        {/* Main Footer */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-12" data-id="element-102">
          {/* Logo & Description */}
          <div className="col-span-2 md:col-span-1" data-id="element-103">
            <a href="#" className="flex items-center space-x-1 mb-4" data-id="element-104">
              <span className="font-heading font-bold text-xl text-white" data-id="element-105">
                TrackerSpace
              </span>
              <span className="font-heading font-bold text-xl text-brand-accent" data-id="element-106">
                Mx
              </span>
            </a>
            <p className="font-body text-sm text-brand-text-secondary mb-4" data-id="element-107">
              Rastreo satelital profesional para vehículos y flotillas en
              México.
            </p>
            <div className="flex items-center gap-2 text-brand-text-secondary" data-id="element-108">
              <MapPinIcon className="w-4 h-4 text-brand-accent" data-id="element-109" />
              <span className="font-body text-sm" data-id="element-110">Ciudad de México</span>
            </div>
          </div>

          {/* Empresa */}
          <div data-id="element-111">
            <h4 className="font-subheading font-semibold text-white mb-4" data-id="element-112">
              Empresa
            </h4>
            <ul className="space-y-3" data-id="element-113">
              {footerLinks.empresa.map(link => <li key={link.label} data-id="element-114">
                  <a href={link.href} className="font-body text-sm text-brand-text-secondary hover:text-brand-accent transition-colors" data-id="element-115">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Soluciones */}
          <div data-id="element-116">
            <h4 className="font-subheading font-semibold text-white mb-4" data-id="element-117">
              Soluciones
            </h4>
            <ul className="space-y-3" data-id="element-118">
              {footerLinks.soluciones.map(link => <li key={link.label} data-id="element-119">
                  <a href={link.href} className="font-body text-sm text-brand-text-secondary hover:text-brand-accent transition-colors" data-id="element-120">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Productos GPS */}
          <div data-id="element-121">
            <h4 className="font-subheading font-semibold text-white mb-4" data-id="element-122">
              Productos GPS
            </h4>
            <ul className="space-y-3" data-id="element-123">
              {footerLinks.productos.map(link => <li key={link.label} data-id="element-124">
                  <a href={link.href} className="font-body text-sm text-brand-text-secondary hover:text-brand-accent transition-colors" data-id="element-125">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Contacto */}
          <div data-id="element-126">
            <h4 className="font-subheading font-semibold text-white mb-4" data-id="element-127">
              Contacto
            </h4>
            <ul className="space-y-3" data-id="element-128">
              {footerLinks.contacto.map(link => <li key={link.label} data-id="element-129">
                  <a href={link.href} className="font-body text-sm text-brand-text-secondary hover:text-brand-accent transition-colors" data-id="element-130">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-cyan-subtle" data-id="element-131">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-132">
            <p className="font-body text-sm text-brand-text-secondary text-center md:text-left" data-id="element-133">
              © 2025 TrackerSpaceMx · Todos los derechos reservados · Rastreo
              Satelital Profesional en México
            </p>
            <div className="flex items-center gap-6" data-id="element-134">
              <a href="#" className="font-body text-sm text-brand-text-secondary hover:text-brand-accent transition-colors" data-id="element-135">
                Aviso de Privacidad
              </a>
              <a href="#" className="font-body text-sm text-brand-text-secondary hover:text-brand-accent transition-colors" data-id="element-136">
                Términos de Servicio
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}